import * as React from "react";
import { observer } from "mobx-react";
import { AppNavigation } from "./AppNavigation";
import { AppQuickNavigation } from "./AppQuickNavigation";
import { DialogBox } from "./DialogBox";
import { ProgressBar } from "./ProgressBar";
import { NotificationBox } from "./NotificationBox";
import { Head } from "./Head";
import { AppStore } from "../Stores/AppStore";
import * as SettingsManagement from "../SettingsManagement";
import { DialogStore } from "../Stores/DialogStore";

let customHeaderScriptContent = "";

getCustomScript().then(function (result) {
	if (result) {
		customHeaderScriptContent = result;
	}
});

async function getCustomScript(): Promise<string> {
	let scriptData: any = "";
	try {
		scriptData = await SettingsManagement.getCustomScriptContentAsync();

	}
	catch (error) {
		DialogStore.showError(this.props.appStore.localizedStrings.general.generalErrorTitle, error);
	}
	return scriptData;
}

interface IMasterProps {
	path: string;
}




@observer
export class Master extends React.Component<IMasterProps, {}> {

	componentWillMount() {
		window.addEventListener('beforeunload', AppStore.keepOnPageRedirect);
	}

	componentWillUnmount() {
		window.removeEventListener('beforeunload', AppStore.keepOnPageRedirect);
	}

	render() { 

		var wrapper = document.createElement('div');
		wrapper.innerHTML = customHeaderScriptContent;

		wrapper.childNodes.forEach((item) => {
			if (item.nodeName.toLowerCase() == "script") {
				var script = document.createElement("script");
				const scriptElement = item as HTMLScriptElement;
				scriptElement.getAttributeNames().forEach((x) => {
					script.setAttribute(x, scriptElement.getAttribute(x));
				})

				script.innerHTML = item.textContent;
				document.getElementsByTagName('head')[0].appendChild(script);
			}
		});

		return <div className="app">
			<AppNavigation />
			<Head />
			<AppQuickNavigation path={this.props.path} />
			<div className="app__body">
				{this.props.children}
			</div>

			<NotificationBox />
			<DialogBox />
			<ProgressBar />
		</div>;
	}
}